import { browser } from "$app/environment"

if (browser) {

  Document.prototype.keyEsc = function () {
    this.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape" }))
  }

}
